// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 900px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap { gap: 12px; }

.btn::after { content: '' !important; display: none !important; }

/* ── Two-Column Layout ──────────────────────────────────────────────── */
.two-column-layout {
  display: flex;
  gap: 0;
}

.column-left,
.column-right {
  flex: 1;
  padding: 0 24px;
}

.column-left {
  padding-right: 24px;
}

.column-right {
  padding-left: 24px;
}

.separator {
  width: 2px;
  background-color: #d0d8e0;
  margin: 0;
  min-height: 300px;
}

/* ── Layout adjustments for side-by-side ─────────────────────────── */
.label-width {
  width: 130px;
  flex: 0 0 130px;
  padding-right: 20px;
  margin-right: 12px;
  text-align: left;
  white-space: nowrap;
  line-height: 1.5;
  display: flex;
  align-items: center;
}

.input-width {
  flex: 1;
  line-height: 1.5;
  margin-left: 8px;
}

.row {
  display: flex !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  align-items: center;
  min-height: 40px;
  gap: 8px;
}

.row > * {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.form-control {
  margin-left: 8px;
}

.readonly-field {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  height: 38px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/well-update/well-update.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,cAAc,SAAS,EAAE;;AAEzB,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE,0EAA0E;AAC1E;EACE,aAAa;EACb,MAAM;AACR;;AAEA;;EAEE,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd","sourcesContent":["mat-dialog-content {\n  min-width: 900px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap { gap: 12px; }\n\n.btn::after { content: '' !important; display: none !important; }\n\n/* ── Two-Column Layout ──────────────────────────────────────────────── */\n.two-column-layout {\n  display: flex;\n  gap: 0;\n}\n\n.column-left,\n.column-right {\n  flex: 1;\n  padding: 0 24px;\n}\n\n.column-left {\n  padding-right: 24px;\n}\n\n.column-right {\n  padding-left: 24px;\n}\n\n.separator {\n  width: 2px;\n  background-color: #d0d8e0;\n  margin: 0;\n  min-height: 300px;\n}\n\n/* ── Layout adjustments for side-by-side ─────────────────────────── */\n.label-width {\n  width: 130px;\n  flex: 0 0 130px;\n  padding-right: 20px;\n  margin-right: 12px;\n  text-align: left;\n  white-space: nowrap;\n  line-height: 1.5;\n  display: flex;\n  align-items: center;\n}\n\n.input-width {\n  flex: 1;\n  line-height: 1.5;\n  margin-left: 8px;\n}\n\n.row {\n  display: flex !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  align-items: center;\n  min-height: 40px;\n  gap: 8px;\n}\n\n.row > * {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.form-control {\n  margin-left: 8px;\n}\n\n.readonly-field {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  height: 38px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
